import * as toast from "@zag-js/toast"
import {XIcon} from "lucide-react"

import {IconButton} from "~/components/parkui-generated/icon-button"
import {Toast} from "~/components/parkui-generated/toast"

const TOASTER = Toast.createToaster({
  placement: "top-end",
  overlap: true,
  gap: 16,
})

interface ShowToastOptions {
  title: string
  description: string
  type: toast.Type
}

export const showToast = ({title, description, type}: ShowToastOptions) => {
  // Without the timeout, this causes warnings in the console
  setTimeout(() => {
    TOASTER.create({
      title,
      description,
      type,
    })
  }, 0)
}

export const ToastNotifications = () => (
  <Toast.Toaster toaster={TOASTER}>
    {(toast) => (
      <Toast.Root key={toast.id}>
        <Toast.Title>{toast.title}</Toast.Title>
        <Toast.Description>{toast.description}</Toast.Description>
        <Toast.CloseTrigger asChild>
          <IconButton size="sm" variant="link">
            <XIcon />
          </IconButton>
        </Toast.CloseTrigger>
      </Toast.Root>
    )}
  </Toast.Toaster>
)
